import { Observable } from 'rxjs'

export enum SystemEntityDialogType {
  // invoice
  AddInvoice = 'add-invoice',
  EditInvoice = 'edit-invoice',
  // booking
  AddInquiry = 'add-inquiry',
  EditInquiry = 'edit-inquiry',
  //
  AddGuest = 'add-guest',
  EditGuest = 'edit-guest',

  // inventory
  Inventory = 'inventory',
  EditInventory = 'edit-inventory',
  // rental
  AddRental = 'add-rental',
  AddRentalMulti = 'add-rental-multi',
  AddRentalParentChild = 'add-rental-parent-child',
  EditRental = 'rental',
  // Hold
  AddHoldEvent = 'add-hold-event',
  EditHoldEvent = 'edit-hold-event',
  // Task
  AddTask = 'add-task',
  EditTask = 'edit-task',
  // Expense
  AddExpense = 'add-expense',
  EditExpense = 'edit-expense',
  // rate
  AddRate = 'add-rate',
  EditRate = 'edit-rate',
  GroupRate = 'group-rate',
  // channel
  AddChannel = 'add-channel',
  AddCustomChannel = 'add-custom-channel',
  ImportCalendar = 'import-calendar',
  AddSharingCalendar = 'add-sharing-calendar',
  AddExportCalendar = 'add-export-calendar',
  OpenChannel = 'open-channel',
  OpenChannelConnection = 'open-channel-connection',
  OpenChannelWizard = 'open-channel-wizard',
  OpenChannelConnectionWizard = 'open-channel-connection-wizard',
  // Extra
  AddExtra = 'add-extra',
  EditExtra = 'edit-extra',
  // Incident
  AddIncident = 'add-incident',
  EditIncident = 'edit-incident',
  DraftTasksApproval = 'draft-tasks-approval',
  // Charge
  AddCharge = 'add-charge',
  EditCharge = 'edit-charge',
  // LOS discount
  AddLosDiscount = 'add-los-discount',
  EditLosDiscount = 'edit-los-discount',
  // discount Code
  AddDiscountCode = 'add-discount-code',
  EditDiscountCode = 'edit-discount-code',
  // Vendor
  AddVendor = 'add-vendor',
  EditVendor = 'edit-vendor',
  // Website
  AddWebsite = 'add-website',
  // Template
  AddTemplate = 'add-template',
  EditTemplate = 'edit-template',
  // Device
  AddDevice = 'add-device',
  // Payment Gateway
  AddPaymentGateway = 'add-payment-gateway',
  // Data Feed
  AddDataFeed = 'add-data-feed',
  // Email Forwarding
  AddEmailForwarding = 'add-email-forwarding',
  // Booking Formula
  AddBookingFormula = 'add-booking-formula',
  EditBookingFormula = 'edit-booking-formula',
  // Document
  AddDocument = 'add-document',

  // Automations:   Tasks, Messages, Bookings, Documents, Reviews, Expenses, Invoices,
  OpenAutomationWizard = 'open-automation-wizard',
  AddTaskAutomation = 'add-task-automation',
  AddMessageAutomation = 'add-message-automation',
  AddBookingAutomation = 'add-booking-automation',
  AddDocumentAutomation = 'add-document-automation',
  AddReviewAutomation = 'add-review-automation',
  AddExpenseAutomation = 'add-expense-automation',
  AddInvoiceAutomation = 'add-invoice-automation',
  AddRateAutomation = 'add-rate-automation',
  // Rate automations
  AddChannelAutomations = 'add-channel-automations',
  AddMinStayAutomations = 'add-min-stay-automations',
  AddGapNightAutomations = 'add-gap-night-automations',
  AddLastMinuteAutomations = 'add-last-minute-automations',
}

export const dialogConfigs: Record<
  SystemEntityDialogType | string,
  { component?: () => Promise<any>; module: () => Promise<any>; dialogService?: () => Promise<any> }
> = {
  [SystemEntityDialogType.EditInvoice]: {
    component: () =>
      import('@tv3/containers/invoices/overlays/invoice-overlay/invoice-overlay.component').then(
        (m) => m.InvoiceOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/invoices/overlays/invoice-overlay/invoice-overlay.module').then(
        (m) => m.InvoiceOverlayModule
      ),
  },
  [SystemEntityDialogType.AddInvoice]: {
    dialogService: () =>
      import('@tv3/containers/invoices/invoices/add-invoice/add-invoice-dialog.service').then(
        (m) => m.AddInvoiceDialogService
      ),
    module: () => import('@tv3/containers/invoices/shared/invoices-shared.module').then((m) => m.InvoicesSharedModule),
  },
  // Booking
  [SystemEntityDialogType.EditInquiry]: {
    component: () =>
      import('@tv3/containers/inquiries/overlays/inquiry-overlay/inquiry-overlay.component').then(
        (m) => m.InquiryOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/inquiries/overlays/inquiry-overlay/inquiry-overlay.module').then(
        (m) => m.InquiryOverlayModule
      ),
  },
  [SystemEntityDialogType.AddInquiry]: {
    dialogService: () =>
      import('@tv3/containers/inquiries/dialogs/shared/add-inquiry/add-inquiry-dialog.service').then(
        (m) => m.AddInquiryDialogService
      ),
    module: () =>
      import('@tv3/containers/inquiries/shared/inquiries-shared.module').then((m) => m.InquiriesSharedModule),
  },

  // Guest
  [SystemEntityDialogType.EditGuest]: {
    component: () =>
      import('@tv3/containers/guests/overlays/guest-overlay/guest-overlay.component').then(
        (m) => m.GuestOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/guests/overlays/guest-overlay/guest-overlay.module').then((m) => m.GuestOverlayModule),
  },
  [SystemEntityDialogType.AddGuest]: {
    dialogService: () =>
      import('@tv3/containers/guests/dialogs/guest-dialog/guest-dialog.service').then((m) => m.GuestDialogService),
    module: () => import('@tv3/containers/guests/guests-shared.module').then((m) => m.GuestsSharedModule),
  },

  // Rental
  [SystemEntityDialogType.EditRental]: {
    component: () =>
      import('@tv3/containers/rentals/overlays/rental-overlay/rental-overlay.component').then(
        (m) => m.RentalOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/rentals/overlays/rental-overlay/rental-overlay.module').then(
        (m) => m.RentalOverlayModule
      ),
  },
  [SystemEntityDialogType.AddRental]: {
    module: () => import('@tv3/containers/rentals/rentals-shared.module').then((m) => m.RentalsSharedModule),
    dialogService: () =>
      import('@tv3/containers/rentals/add/add-rental-dialog.service').then((m) => m.AddRentalDialogService),
  },
  [SystemEntityDialogType.AddRentalMulti]: {
    module: () => import('@tv3/containers/rentals/rentals-shared.module').then((m) => m.RentalsSharedModule),
    dialogService: () =>
      import('@tv3/containers/rentals//group/add-multi-unit/add-multi-unit-dialog.service').then(
        (m) => m.AddMultiUnitDialogService
      ),
  },
  [SystemEntityDialogType.AddRentalParentChild]: {
    module: () => import('@tv3/containers/rentals/rentals-shared.module').then((m) => m.RentalsSharedModule),
    dialogService: () =>
      import('@tv3/containers/rentals/group/parent-child-rental-dialog/parent-child-rental-dialog.service').then(
        (m) => m.ParentChildRentalDialogService
      ),
  },

  // Inventory
  [SystemEntityDialogType.Inventory]: {
    component: () =>
      import('@tv3/containers/inventories/overlays/inventory-overlay/inventory-overlay.component').then(
        (m) => m.InventoryOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/inventories/overlays/inventory-overlay/inventory-overlay.module').then(
        (m) => m.InventoryOverlayModule
      ),
  },
  [SystemEntityDialogType.EditInventory]: {
    dialogService: () =>
      import('@tv3/containers/inventories/inventory-dialog/inventory-dialog.service').then(
        (m) => m.InventoryDialogService
      ),
    module: () =>
      import('@tv3/containers/inventories/inventories-shared.module').then((m) => m.InventoriesSharedModule),
  },
  // Hold
  [SystemEntityDialogType.AddHoldEvent]: {
    dialogService: () =>
      import('@tv3/containers/calendar/hold/hold-dialog/hold-dialog.service').then((m) => m.HoldDialogService),
    module: () => import('@tv3/containers/calendar/shared/calendar-shared.module').then((m) => m.CalendarSharedModule),
  },
  [SystemEntityDialogType.EditHoldEvent]: {
    dialogService: () =>
      import('@tv3/containers/calendar/hold/hold-dialog/hold-dialog.service').then((m) => m.HoldDialogService),
    module: () => import('@tv3/containers/calendar/shared/calendar-shared.module').then((m) => m.CalendarSharedModule),
  },
  // Task
  [SystemEntityDialogType.AddTask]: {
    dialogService: () =>
      import('@tv3/containers/tasks/shared/task-dialog/task-dialog.service').then((m) => m.TaskDialogService),
    module: () => import('@tv3/containers/tasks/tasks-shared.module').then((m) => m.TasksSharedModule),
  },
  [SystemEntityDialogType.EditTask]: {
    dialogService: () =>
      import('@tv3/containers/tasks/shared/task-dialog/task-dialog.service').then((m) => m.TaskDialogService),
    module: () => import('@tv3/containers/tasks/tasks-shared.module').then((m) => m.TasksSharedModule),
  },
  // Expense
  [SystemEntityDialogType.AddExpense]: {
    dialogService: () =>
      import('@tv3/containers/expenses/dialogs/add/add-expense-dialog.service').then((m) => m.AddExpenseDialogService),
    module: () => import('@tv3/containers/expenses/shared/expense-shared.module').then((m) => m.ExpenseSharedModule),
  },
  [SystemEntityDialogType.EditExpense]: {
    dialogService: () =>
      import('@tv3/containers/expenses/dialogs/edit/edit-expense-dialog.service').then(
        (m) => m.EditExpenseDialogService
      ),
    module: () => import('@tv3/containers/expenses/shared/expense-shared.module').then((m) => m.ExpenseSharedModule),
  },
  // Rate
  [SystemEntityDialogType.AddRate]: {
    dialogService: () =>
      import('@tv3/containers/rates/edit-rate-dialog/edit-rate-dialog.service').then((m) => m.EditRateDialogService),
    module: () => import('@tv3/containers/rates/rates-shared.module').then((m) => m.RatesSharedModule),
  },
  [SystemEntityDialogType.EditRate]: {
    dialogService: () =>
      import('@tv3/containers/rates/edit-rate-dialog/edit-rate-dialog.service').then((m) => m.EditRateDialogService),
    module: () => import('@tv3/containers/rates/rates-shared.module').then((m) => m.RatesSharedModule),
  },
  [SystemEntityDialogType.GroupRate]: {
    dialogService: () =>
      import('@tv3/containers/rates/account-rates-dialog/account-rates-dialog.service').then(
        (m) => m.AccountRatesDialogService
      ),
    module: () => import('@tv3/containers/rates/rates-shared.module').then((m) => m.RatesSharedModule),
  },
  // channel
  [SystemEntityDialogType.AddChannel]: {
    dialogService: () =>
      import('@tv3/containers/channels/channel-connect/channel-helper.service').then((m) => m.ChannelHelperService),
    module: () => import('@tv3/containers/channels/shared/channel-shared.module').then((m) => m.ChannelSharedModule),
  },
  [SystemEntityDialogType.AddCustomChannel]: {
    dialogService: () =>
      import('@tv3/containers/channels/channel-connect/channel-helper.service').then((m) => m.ChannelHelperService),
    module: () => import('@tv3/containers/channels/shared/channel-shared.module').then((m) => m.ChannelSharedModule),
  },
  [SystemEntityDialogType.ImportCalendar]: {
    dialogService: () =>
      import('@tv3/containers/calendar/shared/import-calendar-dialog/import-calendar-dialog.service').then(
        (m) => m.ImportCalendarDialogService
      ),
    module: () => import('@tv3/containers/calendar/shared/calendar-shared.module').then((m) => m.CalendarSharedModule),
  },
  [SystemEntityDialogType.AddSharingCalendar]: {
    dialogService: () =>
      import('@tv3/containers/calendar/shared/share-calendar-dialog/share-calendar-dialog.service').then(
        (m) => m.ShareCalendarDialogService
      ),
    module: () => import('@tv3/containers/calendar/shared/calendar-shared.module').then((m) => m.CalendarSharedModule),
  },
  [SystemEntityDialogType.AddExportCalendar]: {
    dialogService: () =>
      import(
        '@tv3/containers/channels/channel-connect/dialogs/export-calendar-dialog/export-calendar-dialog.service'
      ).then((m) => m.ExportCalendarDialogService),
    module: () => import('@tv3/containers/channels/shared/channel-shared.module').then((m) => m.ChannelSharedModule),
  },
  [SystemEntityDialogType.OpenChannel]: {
    dialogService: () =>
      import('@tv3/containers/channels/channel-detail/channel-dialog.service').then((m) => m.ChannelDialogService),
    module: () => import('@tv3/containers/channels/shared/channel-shared.module').then((m) => m.ChannelSharedModule),
  },
  [SystemEntityDialogType.OpenChannelConnection]: {
    dialogService: () =>
      import('@tv3/containers/channels/connection-detail/connection-dialog.service').then(
        (m) => m.ConnectionDialogService
      ),
    module: () => import('@tv3/containers/channels/shared/channel-shared.module').then((m) => m.ChannelSharedModule),
  },
  [SystemEntityDialogType.OpenChannelWizard]: {
    dialogService: () =>
      import('@tv3/containers/channels/channel-connect/channel-connect-wizards/index.service').then(
        (m) => m.ChannelConnectWizardsService
      ),
    module: () =>
      import('@tv3/containers/channels/channel-connect/channel-connect-wizards/index.module').then(
        (m) => m.ChannelConnectWizardsModule
      ),
  },
  [SystemEntityDialogType.OpenChannelConnectionWizard]: {
    dialogService: () =>
      import('@tv3/containers/channels/channel-connect/listing-connect-wizards/index.service').then(
        (m) => m.ChannelListingWizardsService
      ),
    module: () =>
      import('@tv3/containers/channels/channel-connect/listing-connect-wizards/index.module').then(
        (m) => m.ChannelListingWizardsModule
      ),
  },

  // Extra
  [SystemEntityDialogType.AddExtra]: {
    dialogService: () =>
      import('@tv3/containers/extras/dialogs/extra-dialog/extra-dialog.service').then((m) => m.ExtraDialogService),
    module: () => import('@tv3/containers/extras/shared/extra-shared.module').then((m) => m.ExtraSharedModule),
  },
  [SystemEntityDialogType.EditExtra]: {
    dialogService: () =>
      import('@tv3/containers/extras/dialogs/extra-dialog/extra-dialog.service').then((m) => m.ExtraDialogService),
    module: () => import('@tv3/containers/extras/shared/extra-shared.module').then((m) => m.ExtraSharedModule),
  },
  // Incident
  [SystemEntityDialogType.AddIncident]: {
    dialogService: () =>
      import('@tv3/containers/incidents/incident-dialog/incident-dialog.service').then((m) => m.IncidentDialogService),
    module: () => import('@tv3/containers/incidents/incidents-shared.module').then((m) => m.IncidentsSharedModule),
  },
  [SystemEntityDialogType.EditIncident]: {
    dialogService: () =>
      import('@tv3/containers/incidents/incident-dialog/incident-dialog.service').then((m) => m.IncidentDialogService),
    module: () => import('@tv3/containers/incidents/incidents-shared.module').then((m) => m.IncidentsSharedModule),
  },
  [SystemEntityDialogType.DraftTasksApproval]: {
    dialogService: () =>
      import('@tv3/containers/tasks/approve-draft-tasks-dialog/approve-draft-tasks-dialog.service').then(
        (m) => m.ApproveDraftTasksDialogService
      ),
    module: () => import('@tv3/containers/tasks/tasks-shared.module').then((m) => m.TasksSharedModule),
  },
  // Charge
  [SystemEntityDialogType.AddCharge]: {
    dialogService: () =>
      import('@tv3/containers/charges/charges/dialogs/charge-dialog/charge-dialog.service').then(
        (m) => m.ChargeDialogService
      ),
    module: () => import('@tv3/containers/charges/charges-shared.module').then((m) => m.ChargesSharedModule),
  },
  [SystemEntityDialogType.EditCharge]: {
    dialogService: () =>
      import('@tv3/containers/charges/charges/dialogs/charge-dialog/charge-dialog.service').then(
        (m) => m.ChargeDialogService
      ),
    module: () => import('@tv3/containers/charges/charges-shared.module').then((m) => m.ChargesSharedModule),
  },
  // LOS discount
  [SystemEntityDialogType.AddLosDiscount]: {
    dialogService: () =>
      import('@tv3/containers/discounts/los-discount/add/add-los-discount-dialog.service').then(
        (m) => m.AddLosDiscountDialogService
      ),
    module: () => import('@tv3/containers/discounts/discounts-shared.module').then((m) => m.DiscountsSharedModule),
  },
  [SystemEntityDialogType.EditLosDiscount]: {
    dialogService: () =>
      import('@tv3/containers/discounts/los-discount/overlay/los-discount-overlay.service').then(
        (m) => m.LosDiscountOverlayService
      ),
    module: () => import('@tv3/containers/discounts/discounts-shared.module').then((m) => m.DiscountsSharedModule),
  },
  // Discount Code
  [SystemEntityDialogType.AddDiscountCode]: {
    dialogService: () =>
      import('@tv3/containers/discounts/discount-code/add/add-discount-code-dialog.service').then(
        (m) => m.AddDiscountCodeDialogService
      ),
    module: () => import('@tv3/containers/discounts/discounts-shared.module').then((m) => m.DiscountsSharedModule),
  },
  [SystemEntityDialogType.EditDiscountCode]: {
    dialogService: () =>
      import('@tv3/containers/discounts/discount-code/overlay/discount-code-overlay.service').then(
        (m) => m.DiscountCodeOverlayService
      ),
    module: () => import('@tv3/containers/discounts/discounts-shared.module').then((m) => m.DiscountsSharedModule),
  },
  // Vendor
  [SystemEntityDialogType.AddVendor]: {
    dialogService: () =>
      import('@tv3/containers/vendors/dialog/vendor-dialog/vendor-dialog.service').then((m) => m.VendorDialogService),
    module: () => import('@tv3/containers/vendors/vendor-shared.module').then((m) => m.VendorsSharedModule),
  },
  [SystemEntityDialogType.EditVendor]: {
    dialogService: () =>
      import('@tv3/containers/vendors/dialog/vendor-dialog/vendor-dialog.service').then((m) => m.VendorDialogService),
    module: () => import('@tv3/containers/vendors/vendor-shared.module').then((m) => m.VendorsSharedModule),
  },

  // Vendor
  [SystemEntityDialogType.AddWebsite]: {
    dialogService: () =>
      import('@tv3/containers/websites/dialogs/add-website-dialog/add-website-dialog.service').then(
        (m) => m.AddWebsiteDialogService
      ),
    module: () => import('@tv3/containers/websites/websites-shared.module').then((m) => m.WebsitesSharedModule),
  },
  // Template
  [SystemEntityDialogType.AddTemplate]: {
    dialogService: () =>
      import('@tv3/containers/templates/template-dialog/template-dialog.service').then((m) => m.TemplateDialogService),
    module: () => import('@tv3/containers/templates/templates-shared.module').then((m) => m.TemplatesSharedModule),
  },
  [SystemEntityDialogType.EditTemplate]: {
    dialogService: () =>
      import('@tv3/containers/templates/template-dialog/template-dialog.service').then((m) => m.TemplateDialogService),
    module: () => import('@tv3/containers/templates/templates-shared.module').then((m) => m.TemplatesSharedModule),
  },
  // Device
  // [SystemEntityDialogType.AddDevice]: {
  //   dialogService: () => import('@tv3/containers/devices/add-device-dialog/add-device-dialog.service').then((m) => m.AddDeviceDialogService),
  //   module: () => import('@tv3/containers/devices/devices-shared.module').then((m) => m.DevicesSharedModule),
  // },
  // Payment Gateway
  // [SystemEntityDialogType.AddPaymentGateway]: {
  //   dialogService: () => import('@tv3/containers/payment-gateways/add-payment-gateway-dialog/add-payment-gateway-dialog.service').then((m) => m.AddPaymentGatewayDialogService),
  //   module: () => import('@tv3/containers/payment-gateways/payment-gateways-shared.module').then((m) => m.PaymentGatewaysSharedModule),
  // },
  // Data Feed
  [SystemEntityDialogType.AddDataFeed]: {
    dialogService: () =>
      import('@tv3/containers/feeds/add/add-feed-dialog.service').then((m) => m.AddFeedDialogService),
    module: () => import('@tv3/containers/feeds/feeds-shared.module').then((m) => m.FeedsSharedModule),
  },
  // Email Forwarding
  [SystemEntityDialogType.AddEmailForwarding]: {
    dialogService: () =>
      import('@tv3/containers/settings/email-options/add-forward-dialog/add-forward-dialog.service').then(
        (m) => m.AddForwardDialogService
      ),
    module: () => import('@tv3/containers/settings/settings-shared.module').then((m) => m.SettingsSharedModule),
  },
  // Booking Formula
  [SystemEntityDialogType.AddBookingFormula]: {
    dialogService: () =>
      import('@tv3/containers/formulas/booking-formula-dialog/booking-formula-dialog.service').then(
        (m) => m.BookingFormulaDialogService
      ),
    module: () => import('@tv3/containers/formulas/formula-shared.module').then((m) => m.BookingFormulaSharedModule),
  },
  [SystemEntityDialogType.EditBookingFormula]: {
    dialogService: () =>
      import('@tv3/containers/formulas/booking-formula-dialog/booking-formula-dialog.service').then(
        (m) => m.BookingFormulaDialogService
      ),
    module: () => import('@tv3/containers/formulas/formula-shared.module').then((m) => m.BookingFormulaSharedModule),
  },
  // Document
  [SystemEntityDialogType.AddDocument]: {
    dialogService: () =>
      import('@tv3/containers/documents/templates/template-drawer/create-template/create-template-drawer.service').then(
        (m) => m.CreateTemplateDrawerService
      ),
    module: () =>
      import('@tv3/containers/documents/templates/templates-shared.module').then((m) => m.TemplatesSharedModule),
  },

  // Automations
  [SystemEntityDialogType.AddTaskAutomation]: {
    component: () =>
      import('@tv3/containers/automations/task/automation-overlay/task-automation-overlay.component').then(
        (m) => m.TaskAutomationOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/automations/task/task-automations.module').then((m) => m.TaskAutomationsModule),
  },
  [SystemEntityDialogType.OpenAutomationWizard]: {
    dialogService: () =>
      import('@tv3/containers/automations/automations-wizard/automations-wizard-dialog.service').then(
        (m) => m.AutomationsWizardDialogService
      ),
    module: () =>
      import('@tv3/containers/automations/automations-wizard/automations-wizard.module').then(
        (m) => m.AutomationsWizardModule
      ),
  },
  [SystemEntityDialogType.AddMessageAutomation]: {
    component: () =>
      import('@tv3/containers/automations/message/automation-overlay/message-automation-overlay.component').then(
        (m) => m.MessageAutomationOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/automations/message/message-automations.module').then((m) => m.MessageAutomationsModule),
  },
  [SystemEntityDialogType.AddBookingAutomation]: {
    component: () =>
      import('@tv3/containers/automations/inquiry/automation-overlay/inquiry-automation-overlay.component').then(
        (m) => m.InquiryAutomationOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/automations/inquiry/inquiry-automations.module').then((m) => m.InquiryAutomationsModule),
  },
  [SystemEntityDialogType.AddDocumentAutomation]: {
    dialogService: () =>
      import('@tv3/containers/documents/automations/automation-overlay/document-automation-overlay.service').then(
        (m) => m.DocumentAutomationOverlayService
      ),
    module: () =>
      import('@tv3/containers/documents/automations/document-automations.module').then(
        (m) => m.DocumentAutomationsModule
      ),
  },
  [SystemEntityDialogType.AddReviewAutomation]: {
    component: () =>
      import('@tv3/containers/automations/review/automation-overlay/review-automation-overlay.component').then(
        (m) => m.ReviewAutomationOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/automations/review/review-automations.module').then((m) => m.ReviewAutomationsModule),
  },
  [SystemEntityDialogType.AddExpenseAutomation]: {
    component: () =>
      import('@tv3/containers/automations/expense/automation-overlay/expense-automation-overlay.component').then(
        (m) => m.ExpenseAutomationOverlayComponent
      ),
    module: () =>
      import('@tv3/containers/automations/expense/expense-automations.module').then((m) => m.ExpenseAutomationsModule),
  },
  [SystemEntityDialogType.AddInvoiceAutomation]: {
    dialogService: () =>
      import('@tv3/containers/invoices/automations/overlay/invoice-automation-overlay.service').then(
        (m) => m.InvoiceAutomationOverlayService
      ),
    module: () => import('@tv3/containers/invoices/shared/invoices-shared.module').then((m) => m.InvoicesSharedModule),
  },
  [SystemEntityDialogType.AddRateAutomation]: {
    dialogService: () =>
      import('@tv3/containers/rates/account-rates-dialog/account-rates-dialog.service').then(
        (m) => m.AccountRatesDialogService
      ),
    module: () => import('@tv3/containers/rates/rates-shared.module').then((m) => m.RatesSharedModule),
  },
  // Rate automations
  [SystemEntityDialogType.AddChannelAutomations]: {
    dialogService: () =>
      import('@tv3/containers/rates/channel-automations/automation-dialog/channel-automation-dialog.service').then(
        (m) => m.ChannelAutomationDialogService
      ),
    module: () =>
      import('@tv3/containers/rates/channel-automations/channel-automations.module').then(
        (m) => m.ChannelAutomationsModule
      ),
  },
  [SystemEntityDialogType.AddMinStayAutomations]: {
    dialogService: () =>
      import('@tv3/containers/rates/min-stay-automations/automation-dialog/min-stay-automation-dialog.service').then(
        (m) => m.MinStayAutomationDialogService
      ),
    module: () =>
      import('@tv3/containers/rates/min-stay-automations/min-stay-automations.module').then(
        (m) => m.MinStayAutomationsModule
      ),
  },
  [SystemEntityDialogType.AddGapNightAutomations]: {
    dialogService: () =>
      import('@tv3/containers/rates/gap-night-automations/automation-dialog/gap-night-automation-dialog.service').then(
        (m) => m.GapNightAutomationDialogService
      ),
    module: () =>
      import('@tv3/containers/rates/gap-night-automations/gap-night-automations.module').then(
        (m) => m.GapNightAutomationsModule
      ),
  },
  [SystemEntityDialogType.AddLastMinuteAutomations]: {
    dialogService: () =>
      import(
        '@tv3/containers/rates/last-minute-automations/automation-dialog/last-minute-automation-dialog.service'
      ).then((m) => m.LastMinuteAutomationDialogService),
    module: () =>
      import('@tv3/containers/rates/last-minute-automations/last-minute-automations.module').then(
        (m) => m.LastMinuteAutomationsModule
      ),
  },
}
